import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'homePage',
      component: ()=> import ('@/components/homePage/homePage'),
      redirect: '/index',
      children:[{
          path: '/index',
          component: () => import('@/components/homePage/index'),
          name: 'index',
          meta: {
            title: '中国建筑工业出版社官网'
          },
        },
        {
          path: '/rights',
          component: () => import('@/components/protectRights/protectRights'),
          name: 'rights',
          meta: {
            title: '维权打盗'
          }
        },
        {
          path: '/info',
          component: () => import('@/components/protectRights/realTimeInfo'),
          name: 'info',
          meta: {
            title: '资讯'
          }
        },
        {
          path: '/service',
          component: () => import('@/components/service/service'),
          name: 'service',
          meta: {
            title: '著译者服务'
          }
        },
        {
          path: '/buyBook',
          component: () => import('@/components/buyBook/buyBook'),
          name: 'buyBook',
          meta: {
            title: '购书导航'
          }
        },
        {
          path: '/newYearSpeech',
          component: () => import('@/components/aboutUs/aboutUs'),
          name: 'aboutUs',
          meta: {
            title: '关于我们'
          },
          children:[
            {
              path: '/newYearSpeech',
              component: () => import('@/components/aboutUs/newYearSpeech'),
              name: 'newYearSpeech',
              meta: {
                title: '新年致辞'
              }
            },
            {
              path: '/ourBrief',
              component: () => import('@/components/aboutUs/ourBrief'),
              name: 'ourBrief',
              meta: {
                title: '本社简介'
              }
            },
            {
              path: '/gloriousCourse',
              component: () => import('@/components/aboutUs/gloriousCourse'),
              name: 'gloriousCourse',
              meta: {
                title: '辉煌历程'
              }
            },
            {
              path: '/organization',
              component: () => import('@/components/aboutUs/organization'),
              name: 'organization',
              meta: {
                title: '组织结构'
              }
            },
            {
              path: '/theOther',
              component: () => import('@/components/aboutUs/theOther'),
              name: 'theOther',
              meta: {
                title: '其他'
              }
            },
          ]
        },
        {
          path: '/dealer',
          component: () => import('@/components/dealer/dealer'),
          name: 'dealer',
          meta: {
            title: '经销商园地'
          }
        },
        {
          path: '/productDetails',
          component: () => import('@/components/productDetails/productDetails'),
          name: 'productDetails',
          meta: {
            title: '商品详情'
          }
        },
        {
          path: "/news",
          component: () => import("@/components/news/news"),
          name: "news",
          meta: { title: "信息动态" }
        },
        {
          path: "/newsdetails",
          component: () => import("@/components/news/newsdetails"),
          name: "newsdetails",
          meta: { title: "新闻详情" }
        },
        {
          path: "/permitFile",
          component: () => import("@/components/publishEle/permitFile"),
          name: "permitFile",
          meta: { title: "出版物经营许可" }
        },
        {
          path: "/official",
          component: () => import("@/components/officialPlatform/official"),
          name: "official",
          meta: { title: "公众号平台" }
        },
      ]
    },
    {
      path: '/login',
      component: () => import('@/components/login/login'),
      name: 'Login',
      meta: {
        title: '欢迎登录',
        requireAuth: true,
        jumpAuth: true
      }
    },
    {
      path: '/register',
      component: () => import('@/components/register/register'),
      name: 'register',
      meta: {
        title: '欢迎注册',
        requireAuth: true
      }
    },
    {
      path: '/payList',
      component: () => import('@/components/pay/pay'),
      name: 'payList',
    },
    {
      path: '/payfinish',
      component: () => import('@/components/payfinish/payfinish'),
      name: 'payfinish',
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js